<template>
  <div>
    <div class="columns is-multiline">
      <div class="column has-text-right">
        <a class="button is-addOrEdit" @click="addOrEditLigne()">
          {{ $t('catalogue.demandeInterventionType.add')}}
        </a>
      </div>
    </div>
    <v-client-table
      :data="produit.demandeInterventionTypes"
      class="overflow-x-auto min-height-50vw"
      :columns="columns"
      :options="options">
      <template slot="ordreRealisation" slot-scope="props">
        <div class="is-pulled-right">
          {{ props.row.ordreRealisation}}
        </div>
      </template>
      <template slot="sujet" slot-scope="props">
        <span> {{ props.row.sujet }}</span>
      </template>
      <template slot="typeDemande" slot-scope="props">
        <span> {{ $t(getTypeDemandeLibelle(props.row.typeDemande)) }} </span>
      </template>
      <template slot="typeOtId" slot-scope="props">
        <span> {{ getTypeOt(props.row.typeOtId) }} </span>
      </template>
      <template slot="edit" slot-scope="props">
        <btn-action-icon
          :tooltip-label="$t('general.button.edit')"
          :permission="permissions.maj"
          @is-click="addOrEditLigne(props.row)"
          icon-type="is-success"
          icon="pencil-box-outline">
        </btn-action-icon>
      </template>
      <template slot="delete" slot-scope="props">
        <btn-action-icon
          :tooltip-label="$t('general.button.delete')"
          tooltipPosition="is-left"
          :permission="permissions.supprimer"
          @is-click="deleteLigne(props)"
          icon-type="is-danger"
          icon="delete-forever">
        </btn-action-icon>
      </template>
    </v-client-table>
    <b-modal v-model="openPopUpDelete" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('catalogue.demandeInterventionType.titlePopup')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="openPopUpDelete = false"
        @yes="deleteDemande()">
      </pop-up-prevention>
    </b-modal>
    <b-modal
      v-model="popupAddEditDemande"
      class="modal"
      has-modal-card>
      <pop-up-add-edit-demande
        :demande="currentDemande"
        :produit="produit"
        :isDetail="detail"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { remove } from '@/api/demandeInterventionType/index';
import { TYPE_INTERVENTION } from '@/configuration/logistique/intervention/interventionConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import PopUpPrevention from '@/components/general/popUpPrevention';
import PopUpAddEditDemande from '@/components/catalogue/produitGeneral/demandeInterventionType/p_addEditDemandeInterventionType';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'demandeInterventionTypes',
  props: {
    produit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  components: {
    BtnActionIcon,
    PopUpPrevention,
    PopUpAddEditDemande,
  },
  data() {
    return {
      constantes: {
        TYPE_INTERVENTION,
      },
      demandeToDeleteId: null,
      openPopUpDelete: false,
      popupAddEditDemande: false,
      currentDemande: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    columns() {
      return ['ordreRealisation', 'typeDemande', 'typeOtId', 'sujet', 'edit', 'delete'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          sujet: this.$t('catalogue.demandeInterventionType.tab.sujet'),
          ordreRealisation: this.$t('catalogue.demandeInterventionType.tab.ordreRealisation'),
          typeDemande: this.$t('catalogue.demandeInterventionType.tab.typeDemande'),
          typeOtId: this.$t('catalogue.demandeInterventionType.tab.typeOt'),
          edit: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          ordreRealisation: 'colonneAction',
          typeDemande: 'colonneWidth250px',
          typeOtId: 'colonneWidth400px',
          delete: 'colonneSelected',
          edit: 'colonneSelected',
        },
        sortable: this.detail ? ['ordreRealisation', 'typeDemande', 'typeOtId', 'sujet'] : [],
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getTypeDemandeLibelle(typeDemande) {
      return this.constantes.TYPE_INTERVENTION.find(type => type.key === typeDemande)?.libelle ?? '';
    },
    getTypeOt(id) {
      return this.typesOT.find(t => t.id === id)?.libelle ?? '';
    },
    deleteLigne(props) {
      if (this.detail) {
        this.demandeToDeleteId = props.row.id;
        this.openPopUpDelete = true;
      } else this.produit.demandeInterventionTypes.splice(props.index - 1, 1);
    },
    async deleteDemande() {
      this.openPopUpDelete = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(this.demandeToDeleteId);
        const index = this.produit.demandeInterventionTypes.findIndex(el => el.id
          === this.demandeToDeleteId);
        this.produit.demandeInterventionTypes.splice(index, 1);
        messageSucces(this.$t('catalogue.demandeInterventionType.deleteSuccess'));
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    addOrEditLigne(demande = null) {
      this.currentDemande = demande;
      this.popupAddEditDemande = true;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      this.produit.demandeInterventionTypes.sort((a, b) => {
        return a.ordreRealisation - b.ordreRealisation;
      });
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style>

</style>
